'use client';
import { InternalError } from '@app/components/templates/internal-error';

export default function ErrorPage() {
    return <InternalError />;
}
